import {IndexPage as ActivityEventsPage} from '../activity-events/pages/IndexPage';

export const ActivityEventsTab = () => {
    return <ActivityEventsPage />;
};
